export const ADMIN_TYPE = {
  ADMIN: 1,
  GENERAL: 2,
} as const

export interface AdminUser {
  id: number
  email: string
  admin_type: number
  client_id: number
  created_at: string
  updated_at: string
}
